import React from 'react'
import _cx from 'classnames/bind'
import SparkleAnimatedIcon from '../../sparkleAnimatedIcon'
import type { CognitionEvaluationGroupMessage } from '@adc/sdk/types'
import cls from './styles.scss'

const cx = _cx.bind(cls)

export interface CognitionProgressMessageProps {
  message: CognitionEvaluationGroupMessage
  index: number
  showAssistantLabel?: boolean
  isActive?: boolean
  isVisible?: boolean
  compact?: boolean
  elmId?: string
}

const CognitionProgressMessage: React.FC<CognitionProgressMessageProps> = ({
  message,
  index,
  showAssistantLabel = true,
  isActive = false,
  isVisible = true,
  compact = false,
  elmId = 'cognition_message',
}) => {
  const description =
    ('description' in message &&
      (message as unknown as { description: string }).description) ||
    ''

  if (!isVisible) return null

  return (
    <div
      className={cx('message', 'ai', { compact })}
      data-elm-id={`${elmId}_progress_container_${index}`}
    >
      {showAssistantLabel && (
        <div className={cx('assistant-label')}>
          <SparkleAnimatedIcon isActive={isActive} />
          <span>AI Assistant</span>
        </div>
      )}
      <div
        className={cx('message-bubble', 'ai')}
        data-elm-id={`${elmId}_progress_bubble_${index}`}
      >
        <span
          className={cx('progress-text', { 'progress-text-active': isActive })}
        >
          {description}
        </span>
      </div>
    </div>
  )
}

export default CognitionProgressMessage
